(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fast-flow-choose"]) return;
  try {
    
$(document).ready(function() {
    $('.sixChoice').on('click', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.six-color').show().focus();  // Shift focus to the "Continue" button
        $('.pchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.oneChoice').on('click', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.one-color').show().focus();  // Shift focus to the "Continue" button
        $('.pchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.extraChoice').on('click', function() {
        $('.pchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.toggle').hide();
        $('.extra').show().focus();  // Shift focus to the "Continue" button
        $('.pchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.llChoice').on('click', function() {
        $('.fchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.ftoggle').hide();
        $('.long-lasting-cta').show().focus();  // Shift focus to the "Continue" button
        $('.fchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.qdChoice').on('click', function() {
        $('.fchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.ftoggle').hide();
        $('.quick-dry-cta').show().focus();  // Shift focus to the "Continue" button
        $('.fchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.mmChoice').on('click', function() {
        $('.fchoices').removeClass('active').addClass('inactive');
        $(this).addClass('active');
        $('.ftoggle').hide();
        $('.mix-match-cta').show().focus();  // Shift focus to the "Continue" button
        $('.fchoices').prop('ariaSelected', false);
        $(this).prop('ariaSelected', true);
    });

    $('.fbacked').on('click', function() {
        $('.formula-pick').hide();
        $('.polish-pick').show().focus();  // Shift focus back to the polish selection section
    });

    $('.six-cta').on('click', function() {
        $('.formula-6').show().focus();  // Shift focus to the formula selection section
        $('.polish-pick').hide();
    });

    $('.one-cta').on('click', function() {
        $('.polish-pick').hide();
        $('.formula-1').show().focus();  // Shift focus to the formula selection section
    });

    $('.dis').on('click', function() {
        $('.error').show().focus();  // Shift focus to the error message
    });
});



  } catch(e) { console.error(e); }
})();
})();
